import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Grid, Button, Icon, Input, Table, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {dateFormatPicker, dateFormatReservation} from '../../common/constants/datesFormat';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import {downloadFile} from '../../common/util/file';
import BoReportTable from './table';
import './boReport.scss';

class BoReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'endDateFilter': moment().format(dateFormatReservation),
      'startDateFilter': moment().format(dateFormatReservation),
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.BoReport,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.deleteBoReportURL();
    this.props.deleteBoReport();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.urlFile !== this.props.urlFile && this.props.urlFile) {
      downloadFile(this.props.urlFile);
      this.props.deleteBoReportURL();
    }
  }

  onSearch = () => {
    const {endDateFilter, startDateFilter} = this.state;
    const ruc = this.props.ruc;
    this.props.deleteBoReportURL();
    this.props.deleteBoReport();
    this.props.reportBoList(startDateFilter, endDateFilter, ruc);
  };

  onDownload = () => {
    const {endDateFilter, startDateFilter} = this.state;
    const ruc = this.props.ruc;
    this.props.reportBoListExcel(startDateFilter, endDateFilter, ruc);
  };

  onOrdersDownload = (type) => {
    const {endDateFilter, startDateFilter} = this.state;
    const ruc = this.props.ruc;
    this.props.reportBoByOrdersList(startDateFilter, endDateFilter, ruc, type);
  };

  changeEndDate = (date) => {
    const dateFormatted = moment(date).format(dateFormatReservation);

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.setState({'endDateFilter': dateFormatted});
  }

  changeStartDate = (date) => {
    const dateFormatted = moment(date).format(dateFormatReservation);
    const {startDateFilter, endDateFilter} = this.state;

    if (dateFormatted === startDateFilter) {
      return;
    }
    this.setState({'startDateFilter': dateFormatted});
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  renderSearchButton() {
    const {loading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary'
        disabled={loading}
        onClick={this.onSearch}
      >
        Consultar
      </Button>
    );
  }

  renderDownloadButton() {
    const {loading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary download'
        disabled={loading}
        onClick={this.onDownload}
      >
        <Icon name='download' />
        Descargar
      </Button>
    );
  }
  renderOrderButton() {
    const {loading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary download'
        disabled={loading}
        onClick={() => this.onOrdersDownload('Ordenes')}
      >
        <Icon name='download' />
        Ordenes
      </Button>
    );
  }

  renderOrder2Button() {
    const {loading} = this.props;
    return (
      <Button
        type= 'button'
        primary
        className='toyota-primary download'
        disabled={loading}
        onClick={() => this.onOrdersDownload('Pedidos')}
      >
        <Icon name='download' />
        Pedidos
      </Button>
    );
  }

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {setReportList, loading} = this.props;
    const {startDateFilter, endDateFilter} = this.state;

    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta Reporte de Bo</h2>
              <div className='title-bar-actions'>
                {this.renderSearchButton()}
                {this.renderDownloadButton()}
                {this.renderOrderButton()}
                {this.renderOrder2Button()}
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Fecha Inicio</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        startDateFilter ?
                          moment(
                            startDateFilter,
                            dateFormatReservation
                          ).toDate() :
                          null
                      }
                      onChange={this.changeStartDate}
                      locale='es'
                      placeholderText='Fecha Inicio'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Fecha Fin</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        endDateFilter ?
                          moment(
                            endDateFilter,
                            dateFormatReservation
                          ).toDate() :
                          null
                      }
                      onChange={this.changeEndDate}
                      locale='es'
                      placeholderText='Fecha Fin'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <Card fluid raised className='container-bo-report'>
          {loading ? this.renderLoader() : <BoReportTable setReportList={setReportList} />}
        </Card>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'setReportList': state.boReport.list,
    'loading': state.boReport.loading,
    'urlFile': state.boReport.urlFile,
    'ruc': state.session.dealerId,
    'setReportListByOrders': state.boReport.listByOrders,
  };
};

const {
  navigateTo,
  deleteUrlVehAudi,
  reportBoList,
  reportBoListExcel,
  deleteBoReport,
  deleteBoReportURL,
  reportBoByOrdersList,
} = Actions;

export default connect(mapStateToProps,
  {
    navigateTo,
    deleteUrlVehAudi,
    reportBoList,
    reportBoListExcel,
    deleteBoReport,
    deleteBoReportURL,
    reportBoByOrdersList,
  })(BoReport);
